import $ from 'jquery';
import Component from '../model/Component';
import Swiper from "swiper";

class GenericSliderComponent extends Component {
    constructor(element, parentCtrl) {
        super(element, parentCtrl);

        this.$element = $(element);

        this.initSwiper();
    }

    initSwiper() {
        let spaceBetween = !!this.$element.data('spacebetween') ? this.$element.data('spacebetween') : 0;
        let checkNavigation = this.$element.parents("[data-navigation-wrapper]");
        let loopSlider = this.$element.data('loop') ?? true;

        let options = {
            slidesPerView: this.$element.data('slidesperview'),
            nextButton: checkNavigation.find('.swiper-button-next')[0],
            prevButton: checkNavigation.find('.swiper-button-prev')[0],
            pagination: checkNavigation.find('.swiper-pagination')[0],
            paginationClickable: true,
            loop: loopSlider,
            spaceBetween: spaceBetween,
            breakpoints: {
                768: {
                    slidesPerView: !!this.$element.data('slidesperviewmobile') ? this.$element.data('slidesperviewmobile') : 1
                }
            },
            observer: true,
            observeParents: true,
        }

        this.swiper = new Swiper(this.$element[0], options);
    }
}

export default GenericSliderComponent;
